import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Paper from '@material-ui/core/Paper';

import { WithApp } from "contexts/appContext";
import { wsGetAll, wsFindBy, wsCreate, wsGet } from "services/WService";
import Draggable from "react-draggable";

const useStyles = makeStyles(() => ({
  closeButton: {
    float: "right"
  }
}));

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default WithApp(function ExchangeSeller(props) {
  const classes = useStyles();

  const showNotify = props.showNotify;

  const { openSetSeller, setOpenSetSeller } = props;

  const handleClose = () => {
    setOpenSetSeller(false);
    setSeller("");
  };

  //cartera (Customer Portfolio)
  const [seller, setSeller] = useState("");
  const [sellerId, setSellerId] = useState(undefined);

  const [customerPId, setCustomerPId] = useState(null);
  const [selectedBureau, setSelectedBureau] = useState(null);

  async function saveExchange(data) {
    let response = await wsCreate('base/customer-portfolio-bureau/set-seller', {
      ...data,
      base_bureau_id: selectedBureau?.id,
    });
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, "error");
    }
  }

  const [sellers, setSellers] = useState([]);
  const [customerPs, setCustomerPs] = useState([]);
  const [bureaus, setBureaus] = useState([]);

  async function listSellers() {
    let response = await wsFindBy("base/seller", "not_assigned", true);
    if (response.success)
      setSellers([{ id: null, SlpCode: '-', SlpName: 'Sin vendedor' }, ...response.data]);
  }

  async function getSeller(idSeller) {
    let response = await wsGet("base/seller", idSeller);
    if (response.success) {
      if (response.data.customerPortfolio !== null) {
        setSeller(response.data.customerPortfolio.description);
      } else {
        setSeller("No tiene cartera");
      }
    }
  }

  async function listBureaus() {
    let response = await wsGetAll("base/bureau");
    if (response.success) setBureaus(response.data);
  }

  async function listCustomerP() {
    let response = await wsGetAll("base/customer-portfolio");
    if (response.success) {
      setCustomerPs(response.data);
    }
  }

  useEffect(() => {
    if (openSetSeller) {
      listSellers();
      listCustomerP();
    }
  }, [openSetSeller]);

  useEffect(() => {
    listBureaus();
  }, []);

  return (
    <div>
      <Dialog open={openSetSeller} onClose={handleClose} fullWidth maxWidth="sm" PaperComponent={PaperComponent}>
        <DialogTitle disableTypography style={{ cursor: 'move' }} id="draggable-dialog-title">
          Asignar cartera a vendedor
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Autocomplete
            options={sellers}
            getOptionLabel={(option) => option.SlpName}
            defaultValue={null}
            renderInput={(params) => <TextField {...params} label="Vendedor" margin="normal" />}
            onChange={(e, item) => {
              if (!!item) {
                if (item.id !== null) {
                  getSeller(item.id);
                }
                setSellerId(item.id);
              } else {
                setSellerId(undefined);
              }
            }}
          />
          <p>Cartera: {seller}</p>
          <div style={{ fontWeight: 'bold', marginTop: '40px' }}>
            {' '}
            Elija cartera que desea asignar:
          </div>

          <Autocomplete
            options={customerPs}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => <TextField {...params} label="Cartera" margin="normal" />}
            onChange={(e, item) => {
              if (!!item) {
                return setCustomerPId(item.id);
              } else {
                setCustomerPId(null);
              }
            }}
          />

          <div style={{ fontWeight: 'bold', marginTop: '40px' }}> Elija la mesa:</div>
          <Autocomplete
            options={bureaus}
            getOptionLabel={(option) => option.description}
            defaultValue={null}
            renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" />}
            onChange={(e, item) => {
              if (!!item) {
                return setSelectedBureau(item);
              } else {
                setSelectedBureau(null);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              saveExchange({
                base_seller_id: sellerId,
                base_customer_portfolio_id: customerPId,
              });
              handleClose();
            }}
            color={props.themeContext.buttonColorSuccess}
            size="sm"
            disabled={sellerId === undefined || customerPId == null || selectedBureau == null}
          >
            Aceptar
          </Button>
          <Button onClick={handleClose} color={props.themeContext.buttonColorDanger} size="sm">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
